import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';

const PickupLocation = ({ pickupLocation }) => {
    return (
        <div className="pt-5 pb-2">
            <h2 className="text-lg font-semibold">Pickup Location</h2>
            {/* <p className="text-sm text-gray-500">Set the location where your trip begins.</p> */}
            <div className="flex justify-between items-center mt-3 p-3 rounded-md bg-gray-100">
                <div className="pl-2 w-5/6">
                    {pickupLocation?.title && (
                        <p className="text-sm font-medium truncate">
                            {pickupLocation.title}
                        </p>
                    )}
                    {pickupLocation?.subText && (
                        <p className="text-xs text-gray-600 line-clamp-3">
                            {pickupLocation.subText}
                        </p>
                    )}
                </div>
                <div className="w-10 h-10 flex items-center justify-center">
                    <FaMapMarkerAlt className="text-xl text-gray-700" />
                </div>
            </div>
        </div>
    );
};

export default PickupLocation;
